<script>
import { handleAlert, handleConfirm } from "@/components/UtilsIf";

export default {
  name: "customerTransfer",
  inject: ["modalData"],
  emits: ["success", "cancel"],
  data() {
    return {
      form: {}
    };
  },
  methods: {
    submit() {
      handleConfirm(
        `请确定是否转移，转移后用户产生的绩效将在次日生效`,
        "warning"
      )
        .then(() => {
          handleAlert("已成功转移", "success");
          this.$emit("success");
        })
        .catch(() => {
          this.$emit('cancel')
        });
    }
  }
};
</script>

<template>
  <!-- 整体表单  -->
  <el-form ref="form" :model="form" label-width="100px">
    <el-form-item
      label="接收人"
      prop="userPhone"
      :rules="[{ required: true, trigger: 'blur' }]"
    >
      <el-select
        v-model="form.status"
        placeholder="请输入或选择接收用户员工"
        clearable
        filterable
      >
        <el-option label="正常" :value="0"></el-option>
        <el-option label="冻结" :value="1"></el-option>
        <el-option label="锁定" :value="2"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<style scoped lang="scss"></style>
